import Store from '../store/store';
import { LOADER } from '../constants/reducerTypes';
import apiConfig from '../app_config/apiConfig';
import AppConfig from '../app_config/appConfig';
import envConfig from '../app_config/envConfig';
import content from '../constants/content';

class UtilityFuntions {
  /**
   * function return the height of element passed based on %.
   *
   * @param {showComplete} show complete section content flag.
   */

  getSectionHeight = (sectionElm, heightPercentage, showComplete) => {
    let contentHeight = 'auto';
    if (sectionElm && sectionElm.current) {
      if (heightPercentage && !showComplete) {
        contentHeight = !Number.isNaN(heightPercentage)
          ? `${(heightPercentage / 100) * sectionElm.current.offsetHeight}px`
          : 'auto';
      }
    }
    return contentHeight;
  };

  // function return the inner text of the html content
  getInnerText = richText => {
    const regex = /(<([^>]+)>)/gi;
    const removeTags = richText && richText.replace(regex, '');
    const txt = document.createElement('textarea');
    txt.innerHTML = removeTags;
    return txt.innerHTML && txt.value;
  };

  // Extracts plain text from an HTML string, removes newlines, and trims extra spaces.
  extractTextFromHtml = htmlString => {
    if (!htmlString) {
      return '';
    }
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Extract the text content and remove newlines
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    return textContent
      .replace(/[\n\r]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  // function to get the highlighted text for Title
  getHitHighlightText = (fieldText, searchTerm) => {
    let highlightedText = fieldText;
    if (fieldText && searchTerm) {
      const wildCardTermText = new RegExp('[^A-Za-z0-9]', 'gi');
      const searchTermArr = searchTerm.split(wildCardTermText);
      searchTermArr.forEach(item => {
        if (item) {
          const matchWord = highlightedText.match(new RegExp(`(\\b${item}\\b)`, 'gi'));
          if (matchWord && matchWord.length > 0) {
            matchWord.forEach(exactMatch => {
              highlightedText = highlightedText.replace(
                new RegExp(`(\\b${exactMatch}\\b)`, 'g'),
                `<Span class="highlight-title">${exactMatch}</span>`,
              );
            });
          }
        }
      });
    }
    return highlightedText;
  };

  // function to get the highlighted text for Description
  getHitHighlightHtml = (fieldHTML, searchTerm, type = 'cardview') => {
    let highlightedText;
    if (type === 'listview') highlightedText = this.extractTextFromHtml(fieldHTML);
    else {
      highlightedText = fieldHTML;
    }
    if (fieldHTML && searchTerm) {
      const getHighLighted = this.getHitHighlightText(this.getInnerText(fieldHTML), searchTerm);
      if (getHighLighted) {
        const index = getHighLighted.indexOf(`<Span class="highlight-title">`);
        if (index > -1) {
          if (index < 150) {
            highlightedText = getHighLighted;
          } else {
            highlightedText = `&#8230;${getHighLighted.substr(
              getHighLighted
                .substr(
                  0,
                  getHighLighted.split(`<Span class="highlight-title">`)[0].lastIndexOf(' '),
                )
                .lastIndexOf(' '),
            )}`;
          }
        }
      }
    }
    return highlightedText;
  };

  // function for return the style based on passed status for cards
  getCardStatusStyle = statusItem => {
    let returnObject = {};
    if (Store.getState().generalData) {
      const configData = Store.getState().generalData.configuration;
      const statusConfig =
        configData &&
        configData.PageConfiguration &&
        configData.PageConfiguration.cardSettings &&
        configData.PageConfiguration.cardSettings.statusStyle;
      if (statusItem && statusConfig) {
        const statusClass = statusItem
          .trim()
          .replaceAll(' ', '')
          .replaceAll('-', '')
          .toLowerCase();
        let styleObj = statusConfig.find(
          o =>
            o.status
              .trim()
              .replaceAll(' ', '')
              .replaceAll('-', '')
              .toLowerCase() === statusClass,
        );
        if (!styleObj) styleObj = statusConfig.find(o => o.status === 'default');
        returnObject = { backgroundColor: styleObj.backgroundColor, color: styleObj.color };
      }
    }
    return returnObject;
  };

  // function for accessing image stream and return the url
  streamBlobToImage = async request => {
    return new Promise((res, rej) => {
      if (request) {
        request
          .then(resData => {
            const reader = resData[0].getReader();
            return new window.ReadableStream({
              start(controller) {
                // The following function handles each data chunk
                function push() {
                  // "done" is a Boolean and value a "Uint8Array"
                  reader.read().then(({ done, value }) => {
                    // If there is no more data to read
                    if (done) {
                      controller.close();
                      return;
                    }
                    // Get the data and send it to the browser via the controller
                    controller.enqueue(value);
                    push();
                  });
                }

                push();
              },
            });
          })
          .then(stream => new window.Response(stream))
          .then(response => response.blob())
          .then(blob => URL.createObjectURL(blob))
          .then(url => {
            res(url);
          })
          .catch(err => rej(err));
      } else res('');
    });
  };

  /*
   * Sanitize the URL based on allowed host
   */
  sanitizeUrl = urlToSanitize => {
    try {
      let url = new URL(urlToSanitize);
      const allowedHosts = ['sites.ey.com', 'eycloudappdev.sharepoint.com'];
      if (!allowedHosts.includes(url.hostname)) return '';
      url = encodeURIComponent(url.href)
        .replaceAll('javascript%3A', '')
        .replaceAll('%3Cscript', '');
      return decodeURIComponent(url);
    } catch (error) {
      window.console.log('Santilize url ', error);
      return '';
    }
  };

  /*
   * Build the share url by sanitizing it
   */
  buildShareUrl = (url, page) => {
    if (page === AppConfig.routePaths.details) {
      const srcParam = this.getUrlParams(url, 'src');
      const shareUrl = srcParam ? this.sanitizeUrl(srcParam) : '';
      return shareUrl
        ? `${apiConfig.appBaseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}/#${
            AppConfig.routePaths.details
          }?src=${shareUrl}`
        : apiConfig.appBaseUrl[process.env.REACT_APP_ENVIRONMENT_NAME];
    }
    return apiConfig.appBaseUrl[process.env.REACT_APP_ENVIRONMENT_NAME];
  };

  // Function to get all query parameter names from a given URL
  getAllQueryParamNames = appUrl => {
    try {
      if (appUrl) {
        const urlString = appUrl.replaceAll('#', 'HasH');
        const url = new URL(urlString);
        return Array.from(url.searchParams.keys());
      }
      return [];
    } catch (error) {
      window.console.log(error);
      return [];
    }
  };

  /*
   *function to return SearchParams from the given url.
   */
  getUrlParams = (appUrl, key) => {
    try {
      let resultData = '';
      if (appUrl) {
        const urlString = appUrl.replaceAll('#', 'HasH');
        const url = new URL(urlString);
        const urlSearchParams = url && url.searchParams && url.searchParams.get(key);
        const hashResetUrl = urlSearchParams && urlSearchParams.replaceAll('HasH', '#');

        if (hashResetUrl && key === 'r') {
          resultData = JSON.parse(hashResetUrl);
        } else if (hashResetUrl) {
          resultData = hashResetUrl;
        }
      }
      return resultData;
    } catch (error) {
      window.console.log(error);
      return '';
    }
  };

  // Convert Byte to Size

  bytesToSize = bytes => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const item = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${Math.round(bytes / 1024 ** item, 2)} ${sizes[item]}`;
  };

  // Function to set the page title
  setPageTitle = titleText => {
    document.title = titleText || content.pageTitle.homePage;
  };

  // function to add and remove the loader queue
  manageLoader = enable => {
    const dispatchData = {
      type: LOADER,
      payload: enable,
    };
    const timeDelay = enable ? 0 : 100;
    setTimeout(() => {
      Store.dispatch(dispatchData);
    }, timeDelay);
  };

  // function to return copy of the array/object passed
  nonRefCopyObject = copyObj => {
    return JSON.parse(JSON.stringify(copyObj));
  };

  /**
   * sort files by name.
   *
   * @param {items} fileObjects
   * @param {name} key to be sorted
   */

  sortByNameHandle = (items, name) => {
    if (items) {
      items.sort((a, b) => {
        const nameA = a[name].toUpperCase(); // ignore upper and lowercase
        const nameB = b[name].toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      return items;
    }
    return items;
  };

  /**
   * groupBy files by file category.
   *
   * @param {array}  file array items
   * @param {Key} key to be grouped
   */
  // Accepts the array and key
  groupByHandle = (array, key) => {
    // Return the end result
    return array.reduce((result, currentValue) => {
      const resultData = { ...result };
      // If an array already present for key, push it to the array. Else create an array and push the object
      (resultData[currentValue[key]] = resultData[currentValue[key]] || []).push(currentValue);
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return resultData;
    }, {}); // empty object is the initial value for result object
  };

  // function to add entry to adobe analytics
  adobeCommonScript = (
    eventName,
    nameofLink,
    componentlinkIdentifier,
    searchKeyword,
    pageName,
    searchMenuItemName,
    searchEventKeyword,
    searchVertical,
    searchResultType,
    fileDownloadName,
    documentFolder,
    listName,
    contentURL,
    fileFormatType,
    searchRefiner,
    docID,
    isSatcall,
    totalNumberOfSearchResults,
    ifo365ResultPresent,
    eventCheck,
    customProperties6,
    elementVal,
    source = ""
  ) => {
    // eslint-disable-next-line no-undef
    adobeAnalytics.AdobeCommonScript(
      eventName,
      nameofLink,
      componentlinkIdentifier,
      searchKeyword,
      pageName,
      searchMenuItemName,
      searchEventKeyword,
      searchVertical,
      searchResultType,
      fileDownloadName,
      documentFolder,
      listName,
      contentURL,
      fileFormatType,
      searchRefiner,
      docID,
      isSatcall,
      totalNumberOfSearchResults,
      ifo365ResultPresent,
      eventCheck,
      customProperties6,
      elementVal,
      source
    );
  };

  //  Function to convert ascii token to hex token in proper format
  getHexToken = value => {
    try {
      const initialTokenValue = `${String.fromCharCode(450)}${String.fromCharCode(450)}`;
      const result = initialTokenValue + this.asciiToHex(value);
      return result;
    } catch (exception) {
      window.console.log('Error in converting token in refiner');
      return '';
    }
  };

  //  Function to convert Ascii To Hex
  asciiToHex = txt => {
    const len = txt.length;
    if (len === 0) {
      return '';
    }
    let hex = '';

    for (let i = 0; i < len; i += 1) {
      const a = txt.charCodeAt(i);
      let h = a.toString(16);
      if (h.length === 1) {
        h = `0${h}`;
      }
      hex += h;
    }
    return hex;
  };

  // check tokenExpired
  checkTokenExpiry = () => {
    let isExpired = true;
    const userProfile = window.localStorage.getItem('userProfile')
      ? JSON.parse(window.localStorage.getItem('userProfile'))
      : null;
    if (userProfile) {
      const { expiresOn } = userProfile;
      const currentTime = new Date().getTime();
      if (currentTime < expiresOn) {
        isExpired = false;
      }
    }
    return isExpired;
  };

  // Function to search for value in the nested array
  findItemNested = (arr, itemId, nestingKey) =>
    arr.reduce((a, item) => {
      if (a) return a;
      if (item.id === itemId) return item;
      if (item[nestingKey]) return this.findItemNested(item[nestingKey], itemId, nestingKey);
      return null;
    }, null);

  // Function to get base URL by passing a URL
  findBaseURL = baseurl => {
    const url = new URL(baseurl);
    return url.origin;
  };

  // function to return image path by interchanging and adding SSA token
  addTokenCdn = (cdnConfig, imagePath) => {
    const url = new URL(imagePath);
    let imgPath = imagePath;
    if (url.origin === cdnConfig.source) {
      imgPath = imagePath.replace(cdnConfig.source, cdnConfig.destination);
    }
    const updatedURL = new URL(imgPath);
    if (updatedURL.origin === cdnConfig.destination && cdnConfig.sasToken) {
      imgPath += `?${cdnConfig.sasToken}`;
    }
    return imgPath;
  };

  // Function to identity the giver url is relative
  isRelativeUrl = urlString => {
    try {
      const hreflink = urlString.replace(/&#58;/g, ':');
      return !new URL(hreflink);
    } catch {
      return true;
    }
  };

  replaceCMSRelativeUrl = richText => {
    // Define a function to check if a URL is relative
    // const isRelativeUrl = (url) => {
    //   return !(/^(?:[a-z]+:)?\/\//i).test(url);
    // };

    // Define the base URL from the environment configuration
    const baseUrl = new URL(envConfig.cmsUrl).origin;

    if (richText !== null && richText !== undefined) {
      // Use a regular expression to find all anchor tags
      return richText.replace(/<a\s+[^>]*href="([^"]*)"[^>]*>/gi, (match, urlString) => {
        // Check if the URL is relative
        if (this.isRelativeUrl(urlString)) {
          // Replace the href attribute with the full URL
          return match.replace(`href="${urlString}"`, `href="${baseUrl}${urlString}"`);
        }
        // If the URL is not relative, return the original match
        return match;
      });
    }
    return richText;
  };

  replaceDefaultRelativeUrl = richText => {
    // Define a function to check if a URL is relative
    // const isRelativeUrl = (url) => {
    //   return !(/^(?:[a-z]+:)?\/\//i).test(url);
    // };

    // Define the base URL from the environment configuration
    const baseUrl = new URL(envConfig.DefaultSharepointURL).origin;

    if (richText !== null && richText !== undefined) {
      // Use a regular expression to find all anchor tags
      return richText.replace(/<a\s+[^>]*href="([^"]*)"[^>]*>/gi, (match, urlString) => {
        // Check if the URL is relative
        if (this.isRelativeUrl(urlString)) {
          // Replace the href attribute with the full URL
          return match.replace(`href="${urlString}"`, `href="${baseUrl}${urlString}"`);
        }
        // If the URL is not relative, return the original match
        return match;
      });
    }
    return richText;
  };

  // Function to validate Empty HTML Tags
  validateEmptyHTMLTags = richText => {
    try {
      if (richText) {
        // Remove zero-width space characters
        const eText = richText.replace(/[\u200B-\u200D\uFEFF]/g, '');
        // Remove HTML tags
        const textWithoutTags = eText.replace(/<[^>]*>/g, '').trim();
        // If there's no text left after removing tags, return an empty string
        if (!textWithoutTags) {
          return '';
        }
      }
      return richText;
    } catch (error) {
      return richText;
    }
  };

  // method to get the date from date string for last updated
  getDate = dateValue => {
    let dateReturnString = '';

    if (dateValue) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      const date = new Date(dateValue);
      const dateString =
        date &&
        date
          .toLocaleDateString('en', options)
          .replace(',', '')
          .split(' ');
      if (
        date &&
        dateString &&
        Array.isArray(dateString) &&
        dateString[0] &&
        dateString[1] &&
        dateString[2]
      ) {
        dateReturnString = `  ${dateString[1]} ${dateString[0]}  ${dateString[2]}`;
      }
      return dateReturnString;
    }

    return dateReturnString;
  };

  // Function to return a random number
  getRandomNumber = () => {
    const crypto = window.crypto || window.msCrypto;
    const array = new Uint32Array(1);

    return crypto.getRandomValues(array)[0];
  };

  // build hierarchical data for Meta data
  buildHierarchicalMetaData = (collections, data, searchResultsModel, termStore) => {
    const metaData = {};
    collections.forEach(item => {
      if (item.dataType === 'taxonomy' && item.id !== 'language') {
        metaData[item.displayProperty] = '';
        const initialData = data[searchResultsModel.getMappedItem(item.displayProperty)]
          ?.split(';')
          ?.filter(val => {
            return val.startsWith('L0|#0');
          })
          ?.map(val => {
            return val
              .split('L0|#0')
              .pop()
              .split('|')[0];
          });
        initialData?.forEach(x => {
          const result = this.findItemNested(
            item.displayProperty === 'owstaxIdEYKDGeoAccess'
              ? termStore.owstaxIdEYKDGeoScope
              : termStore[item.displayProperty],
            x,
            'children',
          );
          if (result !== null)
            metaData[item.displayProperty] += `${result?.pathOfTerm?.replaceAll(';', ' > ')}</br>`;
        });
      } else if (item.id === 'language') {
        metaData[item.displayProperty] = '';
        data[searchResultsModel.getMappedItem(item.displayProperty)]
          ?.split(';')
          ?.filter(val => {
            return val.startsWith('L0|#0');
          })
          ?.map(val => {
            metaData[item.displayProperty] += `${
              val
                .split('L0|#0')
                .pop()
                .split('|')[1]
            }</br>`;
            return null;
          });
      } else {
        metaData[item.displayProperty] =
          data[searchResultsModel.getMappedItem(item.displayProperty)];
      }
    });

    return metaData;
  };

  // function for return the toggle button visibility and flex visibility
  getVisibleStatusStyle = statusItem => {
    let flexVisible = false;
    let buttonVisible = false;

    switch (statusItem) {
      case content.toggleButtonVisiblity.mostPopular:
        flexVisible = true;
        break;
      case content.toggleButtonVisiblity.topic:
        flexVisible = true;
        break;
      case content.toggleButtonVisiblity.recentlyviewed:
        flexVisible = true;
        break;
      case content.toggleButtonVisiblity.recentlyviewAll:
        flexVisible = false;
        buttonVisible = true;
        break;
      case content.toggleButtonVisiblity.resultpage:
        flexVisible = false;
        buttonVisible = true;
        break;
      case content.toggleButtonVisiblity.listpage:
        flexVisible = false;
        buttonVisible = true;
        break;
      default:
        break;
    }

    return { flexVisible, buttonVisible };
  };

  // function for return the group by data based on key
  groupByKey = (array, key) => {
    return array.reduce((hash, obj) => {
      if (obj[key] === undefined) return hash;
      return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) });
    }, {});
  };

  // function for return applied asset pill from app url
  getSelectAssetTypePillFromURL = pageLevelRefiners => {
    const refinementObj = this.getUrlParams(window.location.href, 'r');
    const refinementList = [];
    const pageLevelRefinerObj = {};
    pageLevelRefiners.forEach(x => {
      pageLevelRefinerObj[x.displayProperty] = x;
    });

    if (Array.isArray(refinementObj) && Array.isArray(refinementObj[0])) {
      refinementObj[0].forEach(item => {
        Object.keys(item).forEach(element => {
          if (element === content.Assetpills.managedProperty) {
            refinementList.push(item[element][0].value);
          }
        });
      });
    }
    return refinementList;
  };

  // Function use for validate email
  validateEmail = mail => {
    const regx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; // eslint-disable-line

    return regx.test(mail);
  };

  // Function use for get route from path
  getRouteFromPath = path => {
    const regx = /.+?:\/\/.+?(\/.+?)(?:#|\?|$)/; // eslint-disable-line
    const newPath = regx.exec(path)[1];

    const spliceData = newPath.split('/#/')[1];
    let actionPath = null;

    switch (spliceData) {
      // case "" : actionPath = content.pathContent.homePgae; break;
      case content.pathContent.results:
        actionPath = content.pathContent.search;
        break;
      case content.pathContent.recentlyViewAll:
        actionPath = content.pathContent.recentlyViewAllPage;
        break;
      default:
        actionPath = content.pathContent.homePgae;
        break;
    }

    return actionPath;
  };

  getEndpointName = url => {
    if (!url) return null;
    const cleanUrl = url.split(/[?#]/)[0];
    const trimmedUrl = cleanUrl.endsWith('/') ? cleanUrl.slice(0, -1) : cleanUrl;
    return trimmedUrl.substring(trimmedUrl.lastIndexOf('/') + 1);
  };

  setSessionItem = (key, value) => {
    if (!key) return;
    try {
      // sessionStorage stores strings only. Preserve raw strings, stringify everything else.
      // Convert undefined to null so a stable string is stored.
      const normalized = value === undefined ? null : value;
      const toStore = typeof normalized === 'string' ? normalized : JSON.stringify(normalized);
      window.sessionStorage.setItem(key, toStore);
    } catch (e) {
      // intentionally ignore errors
    }
  };

  getSessionItem = key => {
    if (!key) return null;
    try {
      const raw = window.sessionStorage.getItem(key);
      if (raw === null) return null;
      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    } catch (e) {
      return null;
    }
  };
}

const UtilityService = new UtilityFuntions();
export default UtilityService;
